const getObjectStore = (store_name, mode, db) => {
    return db.transaction(store_name, mode).objectStore(store_name);
};
const openDB = (configMap, success) => {
    // DB 생성
    const req = indexedDB.open(configMap.DATABASE, configMap.DB_VERSION);

    // DB 생성 성공
    req.onsuccess = function() {
        console.log(this.result);
        success(this.result);
    };
    // DB 생성 오류
    req.onerror = function(evt) {
        console.error('indexedDB : ', evt.target.errorCode);
    };
    // DB 마그레이션
    req.onupgradeneeded = function(evt) {
        console.log('indexedDB.onupgradeneeded');
        const store = evt.currentTarget.result.createObjectStore(configMap.DB_STORE_NAME, {
            keyPath: configMap.KEY_PATH,
            autoIncrement: configMap.AUTO_INC
        });

        store.createIndex(configMap.INDEX, configMap.INDEX, { unique: true });
    };
};

const MOVI_CONFIG_MAP = {
    DATABASE: 'FileDatabase',
    DB_VERSION: 1,
    DB_STORE_NAME: 'files',
    KEY_PATH: 'moviNo',
    INDEX: 'moviNo'
};

export default {
    openDB: (configMap, success) => {
        openDB(configMap, success);
    },
    openMoviDB: success => {
        openDB(MOVI_CONFIG_MAP, success);
    },
    moviSetFile: (data, success) => {
        openDB(MOVI_CONFIG_MAP, db => {
            const store = getObjectStore(MOVI_CONFIG_MAP.DB_STORE_NAME, 'readwrite', db);
            let req;

            try {
                req = store.put(data);
            } catch (e) {
                console.log(e);
            }
            console.log('REQ');
            req.onsuccess = evt => {
                success(evt);
            };
        });
    },
    getObjectStore: (store_name, mode, db) => {
        getObjectStore(store_name, mode, db);
    },
    getMoviStore: db => {
        return getObjectStore(MOVI_CONFIG_MAP.DB_STORE_NAME, 'readonly', db);
    },
    getAllData: (callback, db, DB_STORE_NAME) => {
        const store = getObjectStore(DB_STORE_NAME, 'readonly', db);
        const req = store.openCursor();
        req.onsuccess = evt => callback(evt);
    },
    getMovi: (callback, db) => {
        const store = getObjectStore(MOVI_CONFIG_MAP.DB_STORE_NAME, 'readonly', db);
        const req = store.openCursor();
        req.onsuccess = evt => callback(evt);
    },
    clearData: (db, DB_STORE_NAME) => {
        const store = getObjectStore(DB_STORE_NAME, 'readwrite', db);
        const req = store.clear();
        return req;
    },
    deleteData: (id, callback, db, DB_STORE_NAME) => {
        const store = getObjectStore(DB_STORE_NAME, 'readwrite', db);
        store.delete(Number(id)).onsuccess = event => callback(event);
    },
    deleteMovi: (id, callback, db) => {
        const store = getObjectStore(MOVI_CONFIG_MAP.DB_STORE_NAME, 'readwrite', db);
        store.delete(id).onsuccess = event => callback(event);
    },
    putData: (data, db, DB_STORE_NAME) => {
        // 입력한 데이터를 추가한다.
        const store = getObjectStore(DB_STORE_NAME, 'readwrite', db);
        let req;

        try {
            req = store.put(data);
        } catch (e) {
            console.log(e);
        }

        return req;
    },
    putMovi: (data, db) => {
        // 입력한 데이터를 추가한다.
        const store = getObjectStore(MOVI_CONFIG_MAP.DB_STORE_NAME, 'readwrite', db);
        let req;

        try {
            req = store.put(data);
        } catch (e) {
            console.log(e);
        }

        return req;
    },
    addData: (data, db, DB_STORE_NAME) => {
        // 입력한 데이터를 추가한다.
        const store = getObjectStore(DB_STORE_NAME, 'readwrite', db);
        let req;

        try {
            req = store.add(data);
        } catch (e) {
            console.log(e);
        }

        return req;
    }
};
